import { ComponentType } from 'react';

import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { IconProps } from '@/components/icons';
import CalendarBlankIcon from '@/components/icons/calendar-blank';
import SpannerIcon from '@/components/icons/spanner';
import WarningTriangleIcon from '@/components/icons/warning-triangle';
import { cn } from '@/lib/utils';
import { getAWAWorkOrdersQueryOptions } from '@/queries/work-orders';

export const AWAMaintenancePage = () => {
  const { workspaceId } = useParams();
  const { data: workorders } = useQuery(getAWAWorkOrdersQueryOptions({ user: undefined }));

  return (
    <section className="flex flex-col items-center gap-4 p-5">
      <Link to={`/${workspaceId}/workorders`} className="w-full">
        <MaintenancePageCard icon={CalendarBlankIcon} caption="Work Orders" badge={workorders?.totalCount} />
      </Link>
      <Link to={`/${workspaceId}/issues`} className="w-full">
        <MaintenancePageCard icon={WarningTriangleIcon} caption="Issue Repair" />
      </Link>
      <Link to={`/${workspaceId}/schedule-checks`} className="w-full">
        <MaintenancePageCard icon={SpannerIcon} caption="Schedule Check" />
      </Link>
    </section>
  );
};

interface MaintenancePageCardProps {
  icon: ComponentType<IconProps>;
  caption: string;
  badge?: string | number;
  className?: string;
  onClick?: () => void;
}

function MaintenancePageCard({ icon: Icon, caption, badge, className, onClick }: MaintenancePageCardProps) {
  return (
    <div
      className={cn(
        'group relative flex w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-white p-4 shadow-[0_5px_10px_#6e859e1a] transition-colors',
        className,
      )}
      onClick={onClick}>
      <Icon size={48} className="text-default-text" />
      <div className="text-default-text text-lg font-medium">{caption}</div>
      {badge ? (
        <span className="bg-default-red absolute -top-2 -right-2 flex h-6 min-w-6 items-center justify-center rounded-full px-2 text-xs font-medium text-white">
          {badge}
        </span>
      ) : undefined}
    </div>
  );
}
